<div class="kt-grid kt-grid--hor kt-grid--root" *ngIf="appLoad && !selfService">

  <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">

    <stg-ngx-left-nav [menuList]="menuItems" [headerLogo]="logo" [minimizeOnLoad]="true"></stg-ngx-left-nav>

    <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">

      <stg-ngx-header [headerLogo]="logo" [profileImageUrl]="profileImageUrl" [profileMenuItems]="profileMenuItems"></stg-ngx-header>

      <app-page-header></app-page-header>

      <div class="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_content">
        <div class="kt-container kt-grid__item kt-grid__item--fluid kt-container--fluid" *ngIf="loadPages">
          <block-ui>
            <router-outlet></router-outlet>
          </block-ui>
        </div>
      </div>

      <stg-ngx-footer></stg-ngx-footer>

    </div>

  </div>

</div>

<div class="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" *ngIf="appLoad && selfService">
  <div class="kt-container kt-grid__item kt-grid__item--fluid kt-container--fluid">
    <router-outlet></router-outlet>
  </div>
</div>
